class EventEmitter {
  events: Record<string | symbol, Function[]> = {}

  has(name: string | symbol) {
    return !!this.events[name]?.length
  }

  on(name: string | symbol, callback: (...args: any[]) => void) {
    if (this.events[name]) {
      this.events[name].push(callback)
      return
    }
    this.events[name] = [callback]
  }

  off(name: string | symbol, callback?: (...args: any[]) => void) {
    const cbs = this.events[name]
    let liveCbs = []
    if (cbs && callback) {
      for (const cb of cbs) {
        if (cb !== callback) {
          liveCbs.push(cb)
        }
      }
    }

    if (liveCbs.length > 0) {
      this.events[name] = liveCbs
    } else {
      delete this.events[name]
    }
  }

  emit(name: string | symbol, ...args: any[]) {
    const cbs = this.events[name] || []
    for (const cb of cbs) {
      cb.apply(null, args)
    }
  }
}

const emitter = new EventEmitter()

export default emitter
